import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import { QueryBuilder } from '@/core/uql';
import cloneDeep from 'lodash/cloneDeep';

interface DealDetailsState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;

    documents: any[];

    lastMeta: {
      page: number;
      pageSize: number;
      totalCount: number;
      totalPages: number;
  };
}

const state: DealDetailsState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,

    documents: [],

    lastMeta: {
      page: 0,
      pageSize: 0,
      totalCount: 0,
      totalPages: 0
  },
};

const initState = JSON.parse(JSON.stringify(state));

export const actions: ActionTree<DealDetailsState, RootState> = {
  reset({ commit }) {
    commit('RESET_STATE')
  },

  loadData({ commit, getters, dispatch, state }, {documentId, page = 1}) {
    const vm = (this as any)._vm;

    return new Promise((resolve, reject) => {
      commit('START_LOADING');

      state.documentId = documentId;

      vm.$db([
          vm.$q('FEED_DATA')
            .raw('documents.list')
            .action({
              "columns": {
                "id": "f.target_id",
                'type': 'f.type',
                'timestamp': 'f.timestamp',

                "comment_body": "comment.body",
                "comment_recipient_id": "c_recipient.id",
                "comment_recipient_name":  "c_recipient.name",
                "comment_is_client_answer": "comment.is_client_answer",
                "comment_author_id": "c_employee.id",
                "comment_author_name": "c_employee.name",
                "attachments": "comment.attachments",

                "todo_body": "todo.body",
                "todo_type_name": 'type.name',
                "todo_result_body": "todo.result_body",
                "todo_deadline_at": "todo.deadline_at",
                "todo_completed_at": "todo.completed_at",
                "todo_author_id": "t_employee.id",
                "todo_author_name": "t_employee.name",
                "todo_responsible_id": "t_responsible.id",
                "todo_responsible_name": "t_responsible.name",

              },

              "from": "s:feed",
              "from_as": "f",

              "joins": [
                  {
                    "join": "s:todos",
                    "as": "todo",
                    "type": "left",
                    "on": {
                      "$eq": ["todo.id", "f.record_id"]
                    }
                  },
                  {
                    "join": `s:employees`,
                    "type": "left",
                    "as":   `t_employee`,
                    "on": {
                      "$eq": [`t_employee.id`, `todo.author_id`]
                    }
                  },
                  {
                    "join": `s:employees`,
                    "type": "left",
                    "as":   `t_responsible`,
                    "on": {
                      "$eq": [`t_responsible.id`, `todo.responsible_id`]
                    }
                  },
                  {
                    "join": `s:todo_types`,
                    "type": "left",
                    "as":   `type`,
                    "on": {
                      "$eq": [`type.id`, `todo.todo_type_id`]
                    }
                  },
                  //
                  {
                    "join": "s:comments",
                    "as": "comment",
                    "type": "left",
                    "on": {
                      "$eq": ["comment.id", "f.record_id"]
                    }
                  },
                  {
                    "join": `s:employees`,
                    "type": "left",
                    "as":   `c_employee`,
                    "on": {
                      "$eq": [`c_employee.id`, `comment.author_id`]
                    }
                  },
                  {
                    "join": `s:employees`,
                    "type": "left",
                    "as":   `c_recipient`,
                    "on": {
                      "$eq": [`c_recipient.id`, `comment.recipient_id`]
                    }
                  }
              ],

              "where": {
                "$eq": ["f.target_id", {"$": documentId}]
              },

              "order": [
                {"$desc": ["f.timestamp"]}
              ],

              page_size: 10,
              page: page

            }),

      ]).then(((result: ServerResult) => {
          commit('SET_FEED_DATA', result.getOperation('FEED_DATA').getContent());

          commit('LOADED_SUCCESS');

          resolve();
      }));
    })
  },

  loadMore({ commit, getters, dispatch, state }, {documentId}) {
    return dispatch('loadData', { documentId, page: state.lastMeta.page + 1})
  },

  saveComment({ commit, getters, rootState, state }, data) {
    const vm = (this as any)._vm;

    const formData = cloneDeep(data);
    formData.target_id = state.documentId
    formData.author_id = (rootState as any).ubic.actor.document.id

    return new Promise((resolve, reject) => {

      vm.$db([
        vm.$q('SAVE_COMMENT').create('s:comments', formData)
      ])
      .then((result: ServerResult) => {
        resolve();
      });
    })
  },

  saveTodo({ commit, getters, rootState, state }, data) {
    const vm = (this as any)._vm;

    const formData = cloneDeep(data);
    formData.target_id = state.documentId
    formData.author_id = (rootState as any).ubic.actor.document.id

    return new Promise((resolve, reject) => {

      vm.$db([
        vm.$q('SAVE_COMMENT').create('s:todos', formData)
      ])
      .then((result: ServerResult) => {
        resolve();
      });
    })
  },

};

export const mutations: MutationTree<DealDetailsState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      // state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },

  SET_FEED_DATA(state, data) {
      state.documents = [
        ...state.documents,
        ...data.documents
      ];

      state.lastMeta = {
          page: data.meta.page,
          pageSize: data.meta.page_size,
          totalCount: data.meta.total_count,
          totalPages: data.meta.total_pages
      };
      // const documents = data.documents;

      // state.documents = documents
  },

};

export const getters: GetterTree<DealDetailsState, RootState> = {

};

export const STORE_KEY = '$_document_feed';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
